import type { Ref } from 'react';

import type { LegalDocumentSection } from 'services/legal-document-content';
import styles from './LegalDocumentSheet.module.scss';

/** The document's table of contents, and the sheet's landing view. */
export const DocumentOutline = ({
  title,
  effectiveDate,
  sections,
  visited,
  onOpenSection,
  listRef,
}: {
  title: string;
  effectiveDate: string;
  sections: LegalDocumentSection[];
  /** Indices already opened, muted on return. */
  visited: ReadonlySet<number>;
  onOpenSection: (index: number) => void;
  listRef: Ref<HTMLDivElement>;
}) => (
  <div ref={listRef}>
    <h2 className={styles.documentTitle}>{title}</h2>
    <div className={styles.effectiveDate}>Effective {effectiveDate}</div>

    <div className={styles.rows}>
      {sections.map((section, index) => (
        <button
          key={section.heading}
          type="button"
          data-section-index={index}
          className={[styles.row, visited.has(index) ? styles.rowVisited : '']
            .join(' ')
            .trim()}
          onClick={() => onOpenSection(index)}
        >
          {/* Truncated to one line rather than wrapped: the contents are a
              scannable index, and a heading that wraps to three lines turns
              the list back into the wall it exists to replace. The full text
              is still the accessible name of the row. */}
          <span className={styles.rowLabel}>{section.heading}</span>
        </button>
      ))}
    </div>
  </div>
);
